import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {TaskModel} from "../../models/task.model";
import {TaskStatusType} from "../../types/taskStatus.type";

export class taskPlannedEtaCtrl implements IController {

  task: TaskModel;
  timeZoneId: string;
  configZoneId: string;

  private timeZoneOffsetDiff: number;
  public taskStatusType : typeof TaskStatusType = TaskStatusType;

  /* @ngInject */
  constructor(private splitService: SplitService) {}

  $onInit() {
    this.timeZoneOffsetDiff = 0;
  }

  $onChanges(changes) {
    if (changes.configZoneId && !changes.configZoneId.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }
  }

  checkTimeZoneOffsetDiff() {
    const taskEta = _.get(this.task, 'taskSpec.externalPlannedEta') || _.get(this.task, 'routeAnalysis.eta');
    this.timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(this.timeZoneId, taskEta);
    return this.timeZoneOffsetDiff !== 0;
  }

}
angular
  .module('bringoz.admin.tasks')
  .component('taskPlannedEta', {
    bindings: {
      task: '<',
      timeZoneId: '<',
      configZoneId: '<?'
    },
    template: require('./task-planned-eta.html').default,
    controller: taskPlannedEtaCtrl
  });
